import React, { useEffect, useState } from 'react';
import { Alert, Box, Button, CircularProgress, Container, Paper, TextField, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import AuthService from '../logic/AuthService';
import { checkAuthentication } from '../auth/AuthChecker';

const AuthPage: React.FC = () => {
    const navigate = useNavigate();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    useEffect(() => { checkAuthentication().then(ok => ok && navigate('/admin/panel')); }, [navigate]);

    const handleLogin = async (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        setError('');
        setLoading(true);
        try {
            if (await AuthService.processLogIn({ email: email.trim(), password })) navigate('/admin/panel');
            else setError('Не удалось войти. Проверьте почту и пароль.');
        } finally { setLoading(false); }
    };

    return (
        <Box sx={{ minHeight: '100dvh', display: 'grid', placeItems: 'center', p: 2,
            background: 'radial-gradient(circle at 15% 10%, #dde5ed 0, transparent 36%), #f3f1ec' }}>
            <Container maxWidth="xs">
                <Paper component="section" elevation={0} sx={{ p: { xs: 3, sm: 5 }, borderRadius: 4,
                    boxShadow: '0 24px 80px rgba(24,49,83,.13)' }}>
                    <img src="/knopka_main_blue.png" alt="ONE KNOPKA" style={{ width: 132, marginBottom: 32 }} />
                    <Typography variant="h4" gutterBottom>Админ-панель</Typography>
                    <Typography color="text.secondary" sx={{ mb: 3 }}>Управление заказами, каталогом и документами.</Typography>
                    {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
                    <Box component="form" onSubmit={handleLogin}>
                        <TextField required fullWidth label="Email" type="email" autoComplete="email" autoFocus
                            value={email} onChange={e => setEmail(e.target.value)} sx={{ mb: 2 }} />
                        <TextField required fullWidth label="Пароль" type="password" autoComplete="current-password"
                            value={password} onChange={e => setPassword(e.target.value)} sx={{ mb: 3 }} />
                        <Button type="submit" fullWidth variant="contained" disabled={loading}>
                            {loading ? <CircularProgress size={22} color="inherit" /> : 'Войти'}
                        </Button>
                    </Box>
                </Paper>
            </Container>
        </Box>
    );
};

export default AuthPage;
